export default __webpack_public_path__ + "static/media/error.12592c31.svg";